import { useEffect,useState } from "react"
export const Iframe=(props)=>{
 const [state,setState]=useState({loader:true,height:"",width:""})
 let height=9;
 let width=16;
 const changeDimenstion=()=>{
    setState((pre)=>{
        return {...pre,loader:true}
    })
    let innerWidth=window.$("#iframecol").innerWidth();
    let derivedHeight = Math.round((innerWidth*height)/width)
    window.$(".site-loader").remove();
    setState((pre)=>{
        return {...pre,height:derivedHeight,width:innerWidth,loader:false}
    })
 }
 useEffect(()=>{
    changeDimenstion();
     window.$(window).resize(function(){
        changeDimenstion();
    })
 },[])
    return(<>
     <div className="col-12" id="iframecol">
        {!state.loader ? <iframe width={state.width} height={state.height} src={window.env[`REACT_APP_Live_Stream${props.camType}`]} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>:<div>loading...</div>}
        </div>
        </>)
 }